@value swatch-size: 30px;

/* We cannot use noPadding on Button because it adds negative margin. See
related PR for details */
.button-container button {
    padding: 0;
}

.icon-box {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    border: 1px solid var(--border, #ebe8e8);
    background: #fff;
    min-width: 31px;
    min-height: 31px;
    padding-top: 2px;
}

.icon-box:hover {
    background: var(--white);
}

.icon-box--selected {
    composes: icon-box;
    border: 1px solid var(--blue);
}

.icon-box--selected:hover {
    border-color: var(--blue);
    background: var(--white);
}

.color-swatch-button {
    width: swatch-size;
    height: swatch-size;
    background-color: currentColor;
    border: 1px solid var(--white);
    border-radius: 3px;
}

.color-swatch-button--selected {
    width: swatch-size;
    height: swatch-size;
    background-color: currentColor;
    border-radius: 3px;
    border: 1px solid var(--grey-lt);
}

.color-swatch-button:hover {
    border-color: currentColor;
}
